module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-alert', {
    staticClass: "empty-list",
    attrs: {
      "title": _vm.title,
      "description": _vm.description,
      "type": _vm.type,
      "closable": _vm.showCloseButton,
      "show-icon": _vm.showIcon
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-501bcf64!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/list/ListEmpty.vue
// module id = 749
// module chunks = 2